module.exports = __webpack_public_path__ + "img/23.ce66718a.jpg";